// extracted by mini-css-extract-plugin
export default {"root":"styles_root__PVF5d","checkbox":"styles_checkbox__1-HlT","radio":"styles_radio__uLWtl"};